module.exports = __webpack_public_path__ + "static/media/star-preto.d01caf4e.jpg";